import { GET_SESSIONS } from '@/graphql';
import { useLazyQuery } from '@vue/apollo-composable';
import type { Session } from '@/types/composition-functions';

export const useSessions = ({
  getSchoolSessions,
}: {
    getSchoolSessions: { autoFetch?: boolean };
}) => {
  const {
    result: schoolSessions,
    loading: loadingSessions,
    refetch: refetchSessions,
    load: loadSessions,
  } = useLazyQuery<{ schoolSessions: Session[] }>(GET_SESSIONS, undefined);
  if (getSchoolSessions.autoFetch) loadSessions();

  // Use computed to dynamically access the reactive query result
  const sessions = computed(() => schoolSessions.value?.schoolSessions || []);

  return {
    schoolSessions: {
      sessions,
      loading: loadingSessions,
      refetch: refetchSessions,
    },
  };
};
